import React from 'react'
import { View, ViewStyle } from 'react-native'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import { color } from '@trivie/ui-web/theme'
import { Text } from '@trivie/ui-mobile/components/text'

interface RecallTooltipProps {
  handleClose: (event: any) => void
  visible: boolean
  anchorRef?: any
}

export const RecallTooltip = (props: RecallTooltipProps) => {
  const { handleClose, anchorRef, visible } = props

  return (
    <Popper
      aria-label="About Recall"
      open={visible}
      anchorEl={anchorRef?.current}
      role={undefined}
      transition
    >
      {({ TransitionProps, placement }) => (
        <Grow
          timeout={{ appear: 200, enter: 200, exit: 200 }}
          {...TransitionProps}
          style={{
            zIndex: 9999,
            transformOrigin: placement === 'bottom' ? 'center top' : 'center left',
          }}
        >
          <Paper aria-label="Recall" style={{ background: 'transparent' }}>
            <ClickAwayListener onClickAway={handleClose}>
              <View style={CONTAINER}>
                <Text style={{ marginBottom: 4 }} variant="labelEmphasized" tx="Quiz.aboutRecall" />
                <Text
                  style={{ color: '#9098A3', marginBottom: 24 }}
                  variant="body2Medium"
                  tx="Quiz.recallDescription"
                />
              </View>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}

const CONTAINER: ViewStyle = {
  zIndex: 999,
  height: 141,
  //   right: 100,
  width: 257,
  top: -20,
  backgroundColor: color.white,
  shadowColor: '#000',
  shadowRadius: 6,
  shadowOpacity: 0.3,
  shadowOffset: { height: 0, width: 0 },
  borderRadius: 20,
  padding: 20,
}
